"use client";

import { ButtonBlock } from "@/lib/utils/lomdaV3/types";
import { ToolbarDivider, WidthControl } from "./blockAppearance";
import { ButtonActionPopover } from "./buttonActionPopover";
import { ButtonAppearancePopover } from "./buttonAppearancePopover";

export default function ButtonSettings({ block }: { block: ButtonBlock }) {
    return (
        <div className="flex items-center gap-3">
            <WidthControl blockId={block.id} />
            <ToolbarDivider />
            <ButtonActionPopover block={block} />
            <ToolbarDivider />
            <ButtonAppearancePopover block={block} />
        </div>
    );
}
